import React from 'react';
import { Section } from './Section';
import { Store, TrendingUp, Package, Target, BarChart3 } from 'lucide-react';
export function CorrectCustomer() {
  const cards = [{
    icon: <Store className="w-6 h-6 text-accent" data-id="element-52" />,
    title: 'Primera tienda online profesional',
    desc: 'Listo para construir el canal online con criterio desde el primer día.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-accent" data-id="element-53" />,
    title: 'Ventas actuales activas',
    desc: 'Negocios que venden hoy por tienda física, WhatsApp, Instagram o Mercado Libre.'
  }, {
    icon: <Package className="w-6 h-6 text-accent" data-id="element-54" />,
    title: 'Productos físicos y operación real',
    desc: 'Inventario, catálogo y procesos que ya funcionan en el día a día.'
  }, {
    icon: <Target className="w-6 h-6 text-accent" data-id="element-55" />,
    title: 'Decisión seria de canal online',
    desc: 'Buscan una solución profesional, no un experimento.'
  }, {
    icon: <BarChart3 className="w-6 h-6 text-accent" data-id="element-56" />,
    title: 'Inversión estratégica',
    desc: 'Evalúan el ecommerce como un activo comercial, no como un gasto.'
  }];
  return <Section className="bg-white" data-id="element-57">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-58">
        <span className="text-accent font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-59">
          Para quién es
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-6" data-id="element-60">
          Esto es para dueños de pymes retail que no quieren improvisar su salto
          al canal online
        </h2>
        <p className="text-lg text-slate-600" data-id="element-61">
          BitzenEscala™ está diseñado para dueños o socios de pymes retail que
          ya venden productos físicos y necesitan lanzar su primera tienda
          online profesional — o reconstruir una que se hizo sin estructura, sin
          estrategia y sin lógica comercial.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-62">
        {cards.map((card, i) => <div key={i} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-63">
            <div className="bg-white w-12 h-12 rounded-xl flex items-center justify-center shadow-sm mb-4 border border-slate-100" data-id="element-64">
              {card.icon}
            </div>
            <h3 className="font-heading font-bold text-navy-900 mb-2 leading-tight" data-id="element-65">
              {card.title}
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-66">
              {card.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}